export default {
  "content": "<path d=\"M32 415.5l120-320 120 320m-42-112H74m252-64c12.19-28.69 41-48 74-48 46 0 80 32 80 80v144\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M320 358.5c0 36 26.86 58 60 58 54 0 100-27 100-106v-15c-20 0-58 1-92 5-32.77 3.86-68 19-68 58z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};